import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AppStyles from './App.less';
import AppContainer from 'nucleus-guestside-site/src/containers/AppContainer';
import PageRenderer from './PageRenderer';
import { getContentImages } from 'nucleus-themes/getImages';
import CheckoutProcessingDialog from '../dialogs/CheckoutProcessingDialog';
import NavigationDialog from './NavigationDialog';
import baseDialogStyle from '../dialogs/styles/Dialog.less';
import dialogTransitionUpStyle from '../dialogs/styles/DialogTransitionUp.less';
import Form from 'nucleus-form/src/components/Form';
import ThemeImagesContext from 'nucleus-widgets/context/ThemeImagesContext';
import DialogStylesContext from '../dialogs/DialogStylesContext';
import {
  CANCELLATION,
  DECLINE,
  GUEST_REGISTRATION,
  REGISTRATION,
  WAITLIST
} from '../redux/website/registrationProcesses';
import { getDefaultWebsitePageId } from '../redux/website';

class App extends React.Component {
  static displayName = 'App';
  static propTypes = {
    assetRoot: PropTypes.string.isRequired,
    pageId: PropTypes.string.isRequired,
    pages: PropTypes.object,
    theme: PropTypes.object,
    isPageUnderForm: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      themeImages: {
        ...getContentImages(this.props.assetRoot)
      },
      dialogStyles: {
        base: baseDialogStyle,
        transitions: {
          up: dialogTransitionUpStyle
        }
      }
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.assetRoot !== state.assetRoot) {
      return {
        assetRoot: props.assetRoot,
        themeImages: {
          ...getContentImages(props.assetRoot)
        }
      };
    }
    return null;
  }

  renderGuestPage() {
    const { pageId, pages, theme, isPageUnderForm } = this.props;
    return (
      <AppContainer theme={theme}>
        {isPageUnderForm ? (
          <Form>
            <PageRenderer page={pages[pageId]} />
          </Form>
        ) : <PageRenderer page={pages[pageId]} />
        }
      </AppContainer>
    );
  }

  render() {
    return (
      <ThemeImagesContext.Provider value={this.state.themeImages}>
        <DialogStylesContext.Provider value={this.state.dialogStyles}>
          <div className={AppStyles.wrapper}>
            {this.renderGuestPage()}
            <CheckoutProcessingDialog />
            <NavigationDialog />
          </div>
        </DialogStylesContext.Provider>
      </ThemeImagesContext.Provider>
    );
  }
}

export const createApp = (assetRoot) => {
  return connect((state, props) => {
    const { match: { params } } = props;
    const pageId = params.pageId ? params.pageId : getDefaultWebsitePageId(state);
    return {
      assetRoot,
      pageId,
      pages: state.website.pages,
      theme: state.website.theme,
      isPageUnderForm: REGISTRATION.isTypeOfPage(state, pageId) ||
        GUEST_REGISTRATION.isTypeOfPage(state, pageId) ||
        CANCELLATION.isTypeOfPage(state, pageId) ||
        DECLINE.isTypeOfPage(state, pageId) ||
        WAITLIST.isTypeOfPage(state, pageId)
    };
  })(App);
};
